import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { nativeIssueTableEntryPoint } from '@atlassian/jira-native-issue-table/src/ui/entrypoint.tsx';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import formatRulesParameters from '@atlassian/jira-relay/src/__generated__/formatRulesQuery$parameters';
import { expValEquals } from '@atlassian/jira-feature-experiments';

export const issueNavigatorEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-project-issue-navigator-entrypoint" */ './src'),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		const issueKey = fg('slv-4_migrate_nin_selected_issue_route')
			? entryPointParams?.context?.match?.query?.selectedIssue
			: entryPointParams?.context?.match?.params?.issueKey;
		const projectKey = fg('conditional-formatting-new-list-targeting-gate')
			? entryPointParams?.context?.match?.params?.projectKey
			: undefined;
		const { cloudId } = fg('conditional-formatting-new-list-targeting-gate')
			? entryPointParams.tenantContext
			: { cloudId: undefined };

		let preloadProps = {};
		// exclude nativeIssueTableEntryPoint from preloading on the issue route
		if (!issueKey) {
			preloadProps = {
				entryPoints: {
					nativeIssueTableEntryPoint: {
						entryPoint: nativeIssueTableEntryPoint,
						entryPointParams,
					},
				},
			};
		}

		if (
			projectKey &&
			expValEquals('conditional_formatting_in_new_list', 'isEnabled', true, false)
		) {
			preloadProps = {
				...preloadProps,
				queries: {
					formatRulesQuery: {
						options: {
							fetchPolicy: 'network-only' as const,
						},
						parameters: formatRulesParameters,
						variables: {
							cloudId,
							first: 50,
							projectKey,
						},
					},
				},
			};
		}

		return preloadProps;
	},
});
